var pn = window.location.pathname;
if (pageBg.hasOwnProperty(pn)) {
  var phElem = document.getElementById('page-header-bg');
  phElem.style.display = 'block';
  phElem.style.backgroundImage = 'url('+ pageBg[pn].url +')';
  if (pageBg[pn].magassag && pageBg[pn].magassag != '') {
    phElem.style.height = pageBg[pn].magassag +"px";
  }
  if (pageBg[pn].pozicio && pageBg[pn].pozicio != '') {
    phElem.style.backgroundPosition = "center "+ pageBg[pn].pozicio +"px";
  }
}